import React from 'react';
import { Observe } from 'rewire-core';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { makeStyles } from '../utility/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const accordionStyles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flex: '0 1 auto',
    flexDirection: 'column',
    marginBottom: '8px',
    '& .accordion-summary': {
      '& >div': {
        margin: '4px 0',
        color: theme.palette.primary.main,
      },
      paddingLeft: 0,
      minHeight: 32,
    },
    '& .accordion-details': {
      flexDirection: 'column',
      paddingLeft: 0,
    },
  },
  separationBorder: {
    borderBottom: 'solid 1px lightgray',
  },
});

const gridStyles = (theme: Theme) => ({
  grid: {
    '& tbody tr:hover': {
      backgroundColor: theme.palette.neutralLight.main,
    },
    '& tr th div': {
      color: 'white',
      fontStyle: 'normal',
    },
    '& td.readOnly': {
      color: '#0e5170',
      fontStyle: 'italic',
      fontSize: 12,
    },
  },
});

export const useAccordionStyles = makeStyles(accordionStyles);
export const useGridStyles = makeStyles(gridStyles);

export interface IAccordionModel {
  model: { expanded: boolean };
  title: string | ((props: any) => JSX.Element);
}

export default (props: React.PropsWithChildren<IAccordionModel>) => {
  const s = useAccordionStyles(props);
  const Title =
    typeof props.title === 'string' ? (_props: any) => <Typography variant="h5">{props.title}</Typography> : props.title;
  return (
    <Observe>
      {() => (
        <Accordion
          style={{ padding: 0, margin: 0, backgroundColor: 'transparent' }}
          elevation={0}
          classes={s}
          className={classNames(s.root, s.separationBorder)}
          expanded={props.model.expanded}
          onChange={(_evt: object, expanded: boolean) => (props.model.expanded = expanded)}
        >
          <AccordionSummary className="accordion-summary" expandIcon={<ChevronRightIcon />}>
            <Title />
          </AccordionSummary>
          <AccordionDetails className="accordion-details">{props.children}</AccordionDetails>
        </Accordion>
      )}
    </Observe>
  );
};
